module.exports = __webpack_public_path__ + "img/eraser-icon-yellow.0a40d515.png";